import { render, staticRenderFns } from "./importa-inep.vue?vue&type=template&id=299a3ede"
import script from "./importa-inep.vue?vue&type=script&lang=js"
export * from "./importa-inep.vue?vue&type=script&lang=js"
import style0 from "./importa-inep.vue?vue&type=style&index=0&id=299a3ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports